import { Component } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { TranslateModule } from '@ngx-translate/core';
import { NzFooterComponent } from 'ng-zorro-antd/layout';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';

import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [NzGridModule, TranslateModule, NzFooterComponent, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  isLogged: boolean = false;
  companyId: string = '';

  constructor(
    private authService: AuthService,
    private dataService: DataService,

  ) {
    this.authService.isAuthenticatedObservable().subscribe((logged: boolean) => {
      this.isLogged = logged;
    });
    this.dataService.companyId$.subscribe((companyId) => {
      if (companyId) {
        this.companyId = companyId;
      }
    });
  }

  protected getLink(type: string): string {
    const isFasdac = this.companyId === '45C41017';
    switch (type) {
      case 'who':
        return '/who-we-are';
      case 'condition':
        return '/terms-of-use';
      case 'faq':
        return '/faq';
      case 'mail':
        return isFasdac ? 'mailto:myclinicfasdac@europassistance.it' : 'mailto:servizio.clienti.it@redion.com';
      default:
        return '#';
    }
  }

}
